// Outreach approvals — tokens and small helpers shared by the inbox and the panel.
export { S, MANROPE, FOCUS, auDate, auDateTime } from "../social/lib";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/outreach`;

export const STATUS_LABEL = {
  draft: "Draft",
  awaiting_approval: "Awaiting approval",
  sent: "Sent",
  discarded: "Binned",
};

export const STATUS_TONE = {
  draft: { bg: "#F6F4EF", ink: "#59554D", edge: "#DAD5CA" },
  awaiting_approval: { bg: "#FFF7D6", ink: "#8A6D00", edge: "#E8D48A" },
  sent: { bg: "#E3F3E9", ink: "#0E6B3F", edge: "#A9CFBB" },
  discarded: { bg: "#FFF1EC", ink: "#8E3A12", edge: "#F0C4B4" },
};

export const words = (text) => String(text || "").trim().split(/\s+/).filter(Boolean).length;

export const relative = (iso) => {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "—";
  const mins = Math.round((Date.now() - then) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  return days < 31 ? `${days}d ago` : `${Math.round(days / 30)}mo ago`;
};
